import { InsuredInformationBreadcrumb } from 'quick-quote/components'

import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import PATH from 'quick-quote/constants/path'
import { Redirect } from 'react-router-dom'

import ModelFactorSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import BasicPlanMRTA from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan-mrta'
import MRTAProductSelection from './mrta-product-selection'

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  canProceedToCoveragePlan,
  isMRTAProduct,
  editRiderSumAssured,
  editRiderSelectedPlan,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }
  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <div id="basic-plan">
            <div className="content">
              <ModelFactorSelection />
              {isMRTAProduct && <MRTAProductSelection />}
              <BasicPlanMRTA />
            </div>
          </div>
          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
